<template>
    <div>
        <div class="duplicate-job mt-4">
            <h1 class="pt-4 mb-0">Duplicates created</h1>

            <b-container>
                <div class="card">
                    <div class="card-block">
                        <div v-if="!result">Loading results...</div>
                        <product-list v-if="result" :results="result"></product-list>
                    </div>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
  import ProductList from './ProductList.vue'

  export default {
    name: 'duplicateJob',
    props: ['fb'],
    components: {
      ProductList
    },
    data () {
      return {
        result: null
      }
    },
    firebase () {
      return {
        duplicateJob: {
          source: this.fb.database().ref('duplicateJobs/' + this.$route.params.id),
          asObject: true,
          readyCallback () {
            let self = this
            let query = 'products[*'
            this.duplicateJob.createdCodes.forEach((code, index) => {
              if (index > 0) {
                query += '|'
              }
              query += 'code'
              query += '='
              query += code
            })
            query += ']'
            this.$http.get('https://us-central1-mpdb-f158c.cloudfunctions.net/search', {
              params: {
                query: query
              }
            }).then(response => {
              console.log(response)
              self.result = response.body
            })
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/DuplicateJob.vue